// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_1-1uH","Block":"Content__Block_1MG3V","Title":"Content__Title_25hBu","Masonry":"Content__Masonry_IKTE3","MasonryColumn":"Content__MasonryColumn_lyd5G"};